require('vendor/assets/javascripts/flux-dispatchr/Dispatchr.js')
class ShareContext
  constructor: (options = {}) ->
    @dispatcher = new FluxDispatcher
    @actionContext = @getActionContext()
    @componentContext = @getComponentContext()

  @registerStore: FluxDispatcher.registerStore.bind(FluxDispatcher)

  getComponentContext: ->
    executeAction: @executeAction
    getStore: @getStore

  getActionContext: ->
    executeAction: @executeAction
    dispatch: @dispatcher.dispatch.bind(@dispatcher)
    getStore: @getStore

  getStore: (store) =>
    @dispatcher.getStore store

  executeAction: (actionController, payload) =>
    actionController @actionContext, payload

LP.module('Share').ShareContext = ShareContext
